import { render, staticRenderFns } from "./JcdcLogo.vue?vue&type=template&id=35c5e20a&scoped=true"
import script from "./JcdcLogo.vue?vue&type=script&lang=ts"
export * from "./JcdcLogo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c5e20a",
  null
  
)

export default component.exports